interface HeaderProps {
  title: string
  subtitle: string
  roleSwitcher?: {
    value: 'teacher' | 'student'
    onChange: (role: 'teacher' | 'student') => void
  }
  installButton?: {
    onClick: () => void
  }
}

export const Header = ({ title, subtitle, roleSwitcher, installButton }: HeaderProps) => (
  <header className="header-panel">
    <div className="brand-row">
      <div>
        <p className="brand-kicker">Master Slova</p>
        <h1 className="header-title">{title}</h1>
        <p className="header-subtitle">{subtitle}</p>
      </div>
      <div className="header-avatar" aria-hidden="true">MS</div>
    </div>

    <div className="header-actions">
      {roleSwitcher ? (
        <div className="header-role-switch">
          <label htmlFor="header-role-switch-select">Режим</label>
          <select
            id="header-role-switch-select"
            value={roleSwitcher.value}
            onChange={(event) => {
              const nextRole = event.target.value === 'teacher' ? 'teacher' : 'student'
              roleSwitcher.onChange(nextRole)
            }}
          >
            <option value="student">Студент</option>
            <option value="teacher">Преподаватель</option>
          </select>
        </div>
      ) : null}

      {installButton ? (
        <button
          type="button"
          className="header-install-btn"
          onClick={installButton.onClick}
        >
          На главный экран
        </button>
      ) : null}
    </div>

  </header>
)
